import { format } from 'date-fns';

export const routerPath = {
  root: '/users-attendance-report-studio-Facility-admin',
};

export const getColumns = () => [
  {
    id: 'visitTime',
    label: 'Date/Time',
    customValue: (val) => format(new Date(val.visitTime), 'dd MMMM yyyy pp'),
    align: 'left',
  },
  { id: 'facilityName', label: 'Facility Name', align: 'center' },
  { id: 'className', label: 'Class', align: 'center' },
  { id: 'userName', label: 'Name', align: 'center' },
  { id: 'userSex', label: 'Sex', align: 'center' },
  { id: 'userAge', label: 'Age', align: 'center' },
];

export const getFilters = ({ selectedClass, dateRange, options }) => {
  const classesOptions = () =>
    options?.classes?.map
      ? options.classes.map((item) => ({
          name: item.className,
          id: item.id,
        }))
      : [];

  return [
    {
      id: 'dateRange',
      variant: 'dateTime',
      type: 'dateRange',
      value: dateRange.value,
      action: dateRange.change,
    },
    {
      id: 'classId',
      type: 'select',
      label: 'Class',
      value: selectedClass.value,
      action: selectedClass.change,
      items: ['all', ...classesOptions()],
    },
  ];
};
